namespace Shared.Infrastructure

open System

[<RequireQualifiedAccess>]
module Math =
    let round (digits: int) (value: float) : float = Math.Round(value, digits)